import React from 'react'
import BoxContainer from './BoxContainer'
import Text from 'core-system/Text'
import launchProgramsWordings from '../../Shared/wordings.json'
import { ReactComponent as HelpIcon } from './help-icon.svg'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const HelpIconStyled = styled(HelpIcon)`
  width: 1.25rem;
  height: 1.25rem;
  color: ${(props) => props.theme.palette.grey.grey600};
`

const LinkStyled = styled(Link)`
  color: ${(props) => props.theme.palette.accent.blue500};
  text-decoration: none;
`

const NeedAssistanceBox = () => {
  return (
    <BoxContainer>
      <TitleContainer>
        <HelpIconStyled />
        <Text variant='action4'>
          {launchProgramsWordings.needAssistanceBox.title}{' '}
          <LinkStyled to='mailto:support@movewithfleet.com'>
            support@movewithfleet.com
          </LinkStyled>
        </Text>
      </TitleContainer>
    </BoxContainer>
  )
}

export default NeedAssistanceBox
